import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SpSwitchComponent } from '@ui/sp-switch';
import { ReactiveFormsModule } from '@angular/forms';

import { SpAdvancedBorderSettingsComponent } from '@components/sp-advanced-border-settings/sp-advanced-border-settings.component';
import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';
import { SpFormControlsModule } from '@components/sp-form-controls';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SpSwitchComponent,
        ReactiveFormsModule,
        SpFormControlsModule,
        SpColorPickerModule,
        TooltipModule,
        SpAdvancedBorderSettingsComponent,
    ],
    exports: [SpAdvancedBorderSettingsComponent],
})
export class SpAdvancedBorderSettingsModule {}
